export default "__VITE_ASSET__BJjO4I_d__"